import {
    ajusteNomClasse,
    ajusteNomGenre,
    ajusteNomNombre,
    ajusteNomPersonne,
    ajustePrononciations,
    remplaceSoulignement,
    récupèreListeMEQ,
    récupèreValeurRO
} from './utilitaires.js';
import {opérateurParDéfaut, TypeSaisieValeur} from "./constantes.js";
import {Cibles} from "./Cibles.js";
import {Comparateurs} from "./ComparateurCritère.js";
import {CritèreRecherche} from "./CritèreRecherche.js";
import {OptionRecherche} from "./OptionRecherche.js";


export let typeSaisieCourant;

export function appendTd(trÉlément, valeur, classes, isHTML) {
    const tdÉlément = document.createElement("td");
    if (isHTML) {
        tdÉlément.innerHTML = valeur;
    } else {
        tdÉlément.textContent = valeur;
    }

    tdÉlément.classList.add(...classes);

    trÉlément.appendChild(tdÉlément);

    return tdÉlément;
}

export function getIcôneLiÉlément(nomClasse, href, titre) {
    const liÉlément = document.createElement("li");
    liÉlément.classList.add("lienMot");
    const aÉlément = document.createElement("a");
    aÉlément.href = href;
    aÉlément.target = "_BLANK";
    aÉlément.style.textDecoration = "none";
    const iÉlément = document.createElement("i");
    iÉlément.classList.add("icon", nomClasse);
    iÉlément.title = titre;
    aÉlément.appendChild(iÉlément);
    liÉlément.appendChild(aÉlément);
    return liÉlément;
}

export function getTdLiensÉlément(mot) {
    const liensTd = document.createElement("td");
    liensTd.classList.add("liens");

    const ulLiensÉlément = document.createElement("ul");
    ulLiensÉlément.classList.add("liensMot");
    liensTd.appendChild(ulLiensÉlément);

    const nomFichierSansExt = mot.nomFichierSource.replace(/\.ad$/, '');
    ulLiensÉlément.appendChild(
        getIcôneLiÉlément("i-article", `/définitions/${nomFichierSansExt}`,
            "Article de dictionnaire")
    );

    ulLiensÉlément.appendChild(
        getIcôneLiÉlément("i-menu-listes", `/définitions/${nomFichierSansExt}/lexies`, 'Unités lexicales')
    );

    ulLiensÉlément.appendChild(
        getIcôneLiÉlément("i-exemplification",
            `/définitions/${nomFichierSansExt}/exemples_cooccurrents_citations`,
            "Exemplification")
    );

    return liensTd;
}

export function écouter(e) {

    console.debug("TODO : écouter la prononciation du mot", e.target.dataset.motId);

}

export function getTrMot(mot, motIdx) {

    const trÉlément = document.createElement("tr");
    //trÉlément.title = `Ligne ${motIdx + 1}`;
    trÉlément.appendChild(getTdLiensÉlément(mot));


    appendTd(trÉlément, mot.graphieHTML, ["mot"], true);

    const roTdÉlément = appendTd(trÉlément, récupèreValeurRO(mot.ro), ["ro"], true);
    const ro = [...roTdÉlément.getElementsByClassName("infobulleDeclencheur")][0]
    if (ro) {
        ro.addEventListener("click", (e) => {
            Infobulles.afficheInfobulle(e.currentTarget);
            e.stopPropagation();
        });
    }

    const prononcTdÉlément = appendTd(trÉlément, ajustePrononciations(mot.prononciations, mot), ["prononciation"], true);
    const headphone = [...prononcTdÉlément.getElementsByClassName("i-headphones")][0]
    if (headphone) {
        // enregistré globalement?
       // headphone.addEventListener("click", écouter);
    }


    const numHomRegEx = /_(\d+)\.ad/;
    let r = numHomRegEx.exec(mot.nomFichierSource);
    const numHom = r ? `${r[1]}. ` : "";
    // FIXME voir Cie - besoin de réindexation complète
    // appendTd(trÉlément, numHom + mot.graphieLemmeHTML, ["lemme"], true);
    appendTd(trÉlément, numHom + mot.graphieLemme, ["lemme"]);

    appendTd(trÉlément, ajusteNomClasse(mot.classe), ["classe"]);
    appendTd(trÉlément, ajusteNomGenre(mot.genre), ["genre"]);
    appendTd(trÉlément, ajusteNomPersonne(mot.personne), ["personne"], true);
    appendTd(trÉlément, ajusteNomNombre(mot.nombre), ["nombre"]);
    appendTd(trÉlément, mot.mode, getClasses("mode"));
    appendTd(trÉlément, remplaceSoulignement(mot.temps), ["temps"]);

    appendTd(trÉlément, récupèreListeMEQ(mot.étiquettes), ["listeMEQ"], true);

    return trÉlément;
}

export function getClasses(colonne) {
    return [colonne];
}

export function chargeSelectValeursTextes(selectElement, valeursTextes, valeurActive) {

    // vider l'élément select (ses éléments option)
    selectElement.innerText = null;

    valeursTextes.forEach(vt => {
        let opt = document.createElement('option');
        opt.value = vt.valeur;
        opt.innerHTML = vt.texte;
        if (vt.valeur === valeurActive) {
            opt.selected = true;
        }
        selectElement.appendChild(opt);
    });

}

export function chargeSelectCodeNomValeurs(selectElement, tousLesCodeNomValeurs, valeurActive) {

    // Convertir la valeur active en un Set pour opération intersection
    let valeurActiveSet = new Set();
    if (valeurActive) {
        valeurActiveSet = new Set(valeurActive.split(opérateurParDéfaut));
    }

    // vider l'élément select (ses éléments option)
    selectElement.innerText = null;

    for (const [clé, codeNom] of Object.entries(tousLesCodeNomValeurs)) {
        let opt = document.createElement('option');

        const valeurs = Array.isArray(codeNom.code) ? codeNom.code.join() : codeNom.code;

        opt.value = valeurs;
        opt.innerHTML = codeNom.nom;

        // Si au moins une valeur du tableau des valeurs possibles (codeNom.code) se trouve dans les valeurs actives
        const optionActive = valeurActive && codeNom.code && valeurActiveSet.has(valeurs);
        if (optionActive) {
            opt.classList.add("actif");
        }
        opt.selected = optionActive;

        selectElement.appendChild(opt);
    }
    selectElement.dispatchEvent(new Event('change'));
}

export function chargeComparateursSupportés(cr, cible, cibleComparateursActifs) {
    //Charger les comparateurs supportés par la cible
    let comparateurs = {};

    Cibles[cible].comparateurs.forEach(op => {
        comparateurs[op.code] = op
    });

    chargeSelectCodeNomValeurs(cr.critèresComparateursChoix, comparateurs, cibleComparateursActifs);
}

export function chargeUlValeurs(ulElement, toutesLesValeurs, valeursActives) {
    ulElement.innerText = null;
    toutesLesValeurs.forEach((valeur, clé) => {

        const id = "cbValMul-" + clé.replace(/ /, "_");

        let liElement = document.createElement("li");
        let inputElement = document.createElement("input");
        inputElement.type = "checkbox";
        inputElement.id = id;
        inputElement.name = clé;
        // Javascript fait un cast du tableau de String en faisant un valeur.join(',')
        inputElement.value = valeur;

        inputElement.checked = (valeursActives && valeursActives.includes(inputElement.value))

        let labelElement = document.createElement("label");
        labelElement.innerText = clé;
        labelElement.htmlFor = id;

        liElement.appendChild(inputElement);
        liElement.appendChild(labelElement);
        ulElement.appendChild(liElement);
    });
}

export function afficheBlocValeurs(cr, typeSaisie) {
    cr.critèreValeurTexte.style.display = "none";
    cr.critèreValeurChoixUnique.style.display = "none";
    cr.critèreValeurChoixMultiples.style.display = "none";
    switch (typeSaisie) {
        case "TEXTE":
            critèreValeurTexte.style.display = "block";
            break;
        case "CHOIX_UNIQUE":
            critèreValeurChoixUnique.style.display = "block";
            break;
        case "CHOIX_MULTIPLE":
            critèreValeurChoixMultiples.style.display = "block";
            break

    }
}

function isEnCoursDeRévision(cibleCritère) {
    return cibleCritère.code.startsWith("MEQ_") && !cibleCritère.code.startsWith("MEQ_LISTE");
}

function nomValeurAffiché(clé, enCoursDeRévision) {
    // return enCoursDeRévision ? `${clé} (en cours de révision)` : clé;
    return clé;
}

export function rempliBlocValeurs(cr, typeSaisie, cibleCritère, valeursActives) {

    const enCoursDeRévision = isEnCoursDeRévision(cibleCritère);

    switch (typeSaisie) {
        case "TEXTE": {
            cr.critèreValeurTexte.value = Array.isArray(valeursActives) && valeursActives.length > 0
                ? valeursActives[0]
                : "";
            break;
        }
        case "CHOIX_UNIQUE": {
            const valeurs = {};
            cibleCritère.valeursPossibles.forEach((valeur, clé) => {
                valeurs[clé] = { code: valeur, nom: nomValeurAffiché(clé, enCoursDeRévision) };
            });
            chargeSelectCodeNomValeurs(cr.critèreValeurChoixUnique, valeurs, valeursActives ? valeursActives[0] : "");
            break;
        }
        case "CHOIX_MULTIPLE": {
            const valeursMap = new Map();
            cibleCritère.valeursPossibles.forEach((valeur, clé) => {
                valeursMap.set(nomValeurAffiché(clé, enCoursDeRévision), valeur);
            });
            chargeUlValeurs(cr.critèreValeurChoixMultiples, valeursMap, valeursActives);
            break;
        }
    }
}

export function afficheValeursCritère(cr) {

    const cible = cr.getCibleCourante();
    const comparateur = cr.getComparateurCourant();

    typeSaisieCourant = getTypeSaisieValeur(cible, comparateur);


    if (cr.recherche && cr.isCritèreActif(cible, comparateur)) {
        const clé = cr.getCléCibleComparateur(cible, comparateur);
        const critère = cr.recherche.critères.get(clé);
        if (critère instanceof CritèreRecherche) {
            // afficher les valeurs actuelles du critère dans la recherche courante (mode édition)"
            rempliBlocValeurs(cr, typeSaisieCourant, Cibles[cible], critère.valeurs);
        }

    } else {
        let cibleCritère = Cibles[cible];
        rempliBlocValeurs(cr, typeSaisieCourant, cibleCritère);
    }

    afficheBlocValeurs(cr, typeSaisieCourant);
    actualiseBoutonsAction(cr);
}

export function actualiseBoutonsAction(cr) {

    const cible = cr.getCibleCourante();
    const comparateur = cr.getComparateurCourant();

    let ajouteCritèreBouton = document.getElementById("ajouteCritèreBouton");
    let supprimeCritèreBouton = document.getElementById("supprimeCritèreBouton");

    let caractèreAdditionnel = cr.hasCritèreActif() ? ' + ' : '';

    if (cr.recherche && cr.isCritèreActif(cible, comparateur)) {
        ajouteCritèreBouton.title = "Modifier le critère";
        ajouteCritèreBouton.innerHTML = `<i class="icon i-recherche"></i>${caractèreAdditionnel}`;
        supprimeCritèreBouton.disabled = false;
        supprimeCritèreBouton.style.visibility = "visible";
    } else {
        ajouteCritèreBouton.title = "Ajouter le critère";
        ajouteCritèreBouton.innerHTML = `<i class="icon i-recherche"></i>${caractèreAdditionnel}`;
        supprimeCritèreBouton.disabled = true;
        supprimeCritèreBouton.style.visibility = "visible";
    }

    ajouteCritèreBouton.style.visibility = "visible";
}

export function getPastilleActions(cr, idPastille) {
    // <i class="icon i-effacer" title="Supprimer le critère"></i>
    const iÉlément = document.createElement("i");
    // iÉlément.classList.add("icon", "i-effacer");
    iÉlément.classList.add("icon", "i-moins_supprimer");
    iÉlément.title = "Supprimer le critère";
    iÉlément.addEventListener("click", (e) => cr.supprimeCritère(idPastille));
    return iÉlément;
}

export function getPastilleValeur(cr, idPastille, cc) {

    const spanÉlément = document.createElement("span");
    const critère = cc ? cc : cr.getCritère(idPastille);
    const critèreCourant = cc ? cc : cr.getCritèreCourant();
    const valeurs = critèreCourant.valeurs;

    // Récupérer et afficher les valeurs
    const typeSaisie = getTypeSaisieValeur(critèreCourant.cible, critèreCourant.comparateur)
    switch (typeSaisie) {
        case TypeSaisieValeur.TEXTE:
            spanÉlément.innerText = valeurs;
            break;
        case TypeSaisieValeur.CHOIX_MULTIPLE:
            let valeurs2 = [];
            Cibles[critère.cible].valeursPossibles.forEach((valeur, clé) => {
                // console.log(clé, valeur, critère.valeurs.includes(valeur.join()));
                if (critère.valeurs.includes(valeur.join())) {
                    valeurs2.push(clé);
                }
            });

            const ulÉlément = document.createElement("ul");
            valeurs2.forEach(v => {
                const liÉlément = document.createElement("li");
                liÉlément.innerText = v;
                ulÉlément.appendChild(liÉlément);
            })
            return ulÉlément;
        case TypeSaisieValeur.CHOIX_UNIQUE:
            spanÉlément.innerText = getCléMapDepuisValeur(Cibles[critère.cible].valeursPossibles, valeurs[0]);
            break;
    }

    return spanÉlément;
}

export function nouveauDivPastille(classe, texte) {
    const divÉlément = document.createElement("div");
    divÉlément.classList.add(classe);
    divÉlément.innerHTML = texte;
    return divÉlément;
}

export function créerPastille(cr, idPastille, critère) {
    // Créer la pastille du critère
    const pastilleÉlément = document.createElement("li");
    pastilleÉlément.id = idPastille;
    pastilleÉlément.classList.add("pastille");
    pastilleÉlément.addEventListener("click", (e) => {
        cr.setCritèreCourant(critère);
    });

    const cible = Cibles[critère.cible];
    const comparateur = Comparateurs[critère.comparateur];
    pastilleÉlément.appendChild(nouveauDivPastille("pastille-cible", cible.nom));
    pastilleÉlément.appendChild(nouveauDivPastille("pastille-comparateur", comparateur.nom));
    pastilleÉlément.appendChild(nouveauDivPastille("pastille-valeur", "")).appendChild(getPastilleValeur(cr, idPastille, critère));
    pastilleÉlément.appendChild(nouveauDivPastille("pastille-actions", "")).appendChild(getPastilleActions(cr, idPastille));
    cr.filtrePastilles.appendChild(pastilleÉlément);
}

export function ajoutePastille(cr, critère) {

    const idPastille = cr.getPastilleId(critère);
    const p = cr.getPastille(critère);

    if (p) {
        mettreÀJourPastille(cr, p, idPastille);
    } else {
        créerPastille(cr, idPastille, critère);
    }
}

export function mettreÀJourPastille(cr, p, idPastille) {
    // Mettre à jour la pastille du critère (recréer les valeurs)
    p.getElementsByClassName("pastille-valeur")[0].remove();
    const pv = nouveauDivPastille("pastille-valeur", "");
    pv.appendChild(getPastilleValeur(cr, idPastille));
    p.getElementsByClassName("pastille-comparateur")[0].after(pv);
}

export function supprimePastille(cr, critère) {
    const p = cr.filtrePastilles.querySelector("#" + cr.getClé(critère));
    if (p) p.remove();
}

export function supprimeToutesLesPastilles(cr) {
    cr.filtrePastilles.innerText = null;
}

export function désactiveCiblesComparateursActifs(cr) {
    Object.values(
        cr.critèresCiblesChoix.getElementsByTagName("option"))
        .forEach(option => option.classList.remove("actif"));

    Object.values(
        cr.critèresComparateursChoix.getElementsByTagName("option"))
        .forEach(option => option.classList.remove("actif"));
}

export function activeCiblesComparateursActifs(cr) {

    const cibles = [...cr.recherche.critères.values()].map(c => c.cible);

    // Positionnement du style "actif" pour les cibles actives
    [...cr.critèresCiblesChoix.getElementsByTagName("option")]
        .forEach(cibleOption => {
                if (cibles.includes(cibleOption.value)) {
                    cibleOption.classList.add("actif");
                } else {
                    cibleOption.classList.remove("actif");
                }
            }
        );

    // Positionnement du style "actif" pour le comparateur de la cible courante
    cr.critèresComparateursChoix.querySelector(`option[value="${cr.getCritèreCourant().comparateur}"]`)

}

export function activePastille(pastilleÉlément) {

    if (!pastilleÉlément) return;

    // Désactiver une éventuelle autre pastille active
    pastilleÉlément.parentElement.querySelectorAll("li.actif")
        .forEach(pastille => pastille.classList.remove("actif"));

    // Activer la pastille
    pastilleÉlément.classList.add("actif");

}

export function cacheRésultats() {
    document.getElementById("résultats-info").style.display = "none";
    document.getElementById("résultats-tableau").style.display = "none";
    document.getElementById("résultats-tableau-lignes").innerText = null;
    document.getElementById("recherche-nom").style.display = "none";
    // Si aucun résultats, ouvrir les options d'affichages car celles-ci empêchent peut-être l'affichage de résultats
    document.getElementById("optionsAffichage").open = true;

}

export function afficheRésultats() {
    document.getElementById("résultats-info").style.display = "flex";
    document.getElementById("résultats-tableau").style.display = "block";

    const nomRechercheÉlément = document.getElementById("recherche-nom");
    if (nomRechercheÉlément.innerText.trim().length === 0) {
        nomRechercheÉlément.style.display = "none";
    } else {
        nomRechercheÉlément.style.display = "block";
    }

}

export function getNombreFr_CA(nbTotal) {
    const nb = nbTotal.toLocaleString("fr-CA");
    return (nb.length === 5 ? nb.replace(/[^0-9]/, "") : nb);
}

export function actualiseRésultatsInfo(données, recherche) {

    const résultatsInfo = données.résultat.résultatsInfo;
    const nbTotal = résultatsInfo.nbTotalRésultats;
    const nbItems = résultatsInfo.nbTotalItems;
    const nbTotalApprox = nbTotal > nbItems ? nbItems : nbTotal;

    const nomRechercheÉlément = document.getElementById("recherche-nom");

    // Essentiel pour éviter injection JS de ne pas utiliser innerHTML
    nomRechercheÉlément.innerText = recherche.nom;

    if (nbTotal > 0) {
        const nbTotalRésultatsÉlément = document.getElementById("pagination-nbTotalRésultats");
        // Le nombre de résultats est approximatif (à cause des doublons) si tous les résultats ne sont pas retournés.
        if(nbTotal > nbItems) {
            const diviseur = nbTotal < 1000 ? 100 : 1000;
            nbTotalRésultatsÉlément.innerText = "plus de " + getNombreFr_CA(Math.floor(nbTotal / diviseur) * diviseur);
        }
        else {
            nbTotalRésultatsÉlément.innerText = getNombreFr_CA(nbTotal);
        }
        afficheRésultats();
    } else {
        cacheRésultats();
    }
}

function ajusteAffichageColonnes(données, pagination, recherche) {
    // Masquer les colonnes entièrement vides
    const colonnesMasquables = ["ro", "mode", "temps", "personne", "genre", "nombre", "listeMEQ"];
    masquerColonnesVides(données.résultat.items, colonnesMasquables, pagination);

    // Exclure colonne lemme si lemme seulement et renommer colonne en mot/lemme
    if (recherche && recherche.options.get(OptionRecherche.FILTRE_LEMMES_SEULEMENT.code).valeur === "oui") {
        masquerColonne("lemme");
        document.getElementById("motsEntête-graphie").querySelector(".nomColonne").innerText = "Mot / Lemme";
    } else {
        démasquerColonne("lemme");
        document.getElementById("motsEntête-graphie").querySelector(".nomColonne").innerText = "Mot";
    }

    // Afficher la colonne NEQ uniquement si une des listes du MEQ figure dans les critères de la recherche
    if(recherche && !recherche.hasCible(Cibles.LISTE_MEQ)) {
        masquerColonne("listeMEQ");
    }

}

export function actualiseLignesRésultats(données, recherche, pagination, tri) {
    const lignesÉlément = document.getElementById("résultats-tableau-lignes");

    // Rempli les lignes de résultat
    lignesÉlément.innerText = null;

    let fin = Math.min(pagination.taillePage, données.résultat.items.length);

    for (let i = 0; i < fin; i++) {
        lignesÉlément.appendChild(getTrMot(données.résultat.items[i], i));
    }

    ajusteAffichageColonnes(données, pagination, recherche);


}

function masquerColonnesVides(données, colonnesMasquables, pagination) {

    const donnéesAffichées = données.filter((e, i) => i < pagination.taillePage);

    colonnesMasquables.forEach(nomColonne => {
        let nomColonneTraduit = (nomColonne === "listeMEQ" ? "étiquettes" : nomColonne);

        // Vérifier s'il existe au moins une valeur pour cette colonne
        let colonneÀConserver = donnéesAffichées
            .some(valeur => (valeur[nomColonneTraduit] !== "" && valeur[nomColonneTraduit].length !== 0));

        if (!colonneÀConserver) {
            masquerColonne(nomColonne);
        } else {
            document.getElementById("motsEntête-" + nomColonne).style.display = "table-cell";
        }
    });
}


function masquerColonne(nomColonne) {
    Object.values(document.getElementsByClassName(nomColonne)).forEach(
        élément => {
            élément.style.display = "none";
        }
    )
    document.getElementById("motsEntête-" + nomColonne).style.display = "none";
}

function démasquerColonne(nomColonne) {
    Object.values(document.getElementsByClassName(nomColonne)).forEach(
        élément => {
            élément.style.display = "table-cell";
        }
    )
    document.getElementById("motsEntête-" + nomColonne).style.display = "table-cell";
}

export function isVerbeDansDonnées(données) {
    let personne = données.find(mot => mot.personne !== "")
    return personne !== undefined;
}

export function getCléMapDepuisValeur(map, valeur) {
    return [...map].find(([key, value]) => valeur === value.join())[0];
}

export function getCléMapDepuisValeur2(map, valeur) {
    return [...map].find(([key, value]) => valeur === value.join());
}

export function getTypeSaisieValeur(cible, comparateur) {

    let nbValeurs = Cibles[cible].valeursPossibles.size;

    if (nbValeurs === 0) {
        return TypeSaisieValeur.TEXTE;
    } else {
        if (comparateur === Comparateurs.ÉGALE.code || comparateur === Comparateurs.EST_DIFFÉRENT.code) {
            return TypeSaisieValeur.CHOIX_UNIQUE;
        } else {
            return TypeSaisieValeur.CHOIX_MULTIPLE;
        }
    }
}
